import { FC } from 'react';
import { Error } from '@mui/icons-material';
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import cn from 'classnames';

import { IFormSelectProps } from './FormSelect.interface';

import './styles.scss';

const FormSelect: FC<IFormSelectProps> = ({
  className,
  variant = 'filled',
  label,
  required,
  input: { name, onChange, value, ...otherInput },
  meta,
  options,
  endAdornment,
  ...other
}) => (
  <FormControl className={cn('form-select', className)} variant={variant}>
    <InputLabel
      className="form-select__label"
      error={meta.error && meta.touched}
      required={required}
    >
      {label}
    </InputLabel>

    <Select
      {...other}
      className="form-select__input"
      name={name}
      error={meta.error && meta.touched}
      inputProps={otherInput}
      onChange={onChange}
      value={value}
      required={required}
      endAdornment={
        meta.error && meta.touched ? (
          <InputAdornment className="form-select__error-icon" position="start">
            <Error color="error" />
          </InputAdornment>
        ) : (
          endAdornment
        )
      }
    >
      {options.map(item => (
        <MenuItem key={item.id} value={item.id}>
          {item.name}
        </MenuItem>
      ))}
    </Select>

    {meta.error && meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
  </FormControl>
);

export default FormSelect;
